import styled, { css } from 'styled-components'

export default styled.i`
  border: solid white;
  margin-left: 7px;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 2px;

  ${(props) =>
    props.up &&
    css`
      transform: translateY(0px) rotate(-135deg);
    `};

  ${(props) =>
    props.down &&
    css`
      transform: translateY(-2px) rotate(45deg);
    `};

  @media (max-width: 1199px) {
    border-width: 0 2px 2px 0;
    padding: 3px;
    border-color: #fff;
  }
`
